import * as React from 'react';
import classNames from 'classnames';
import useClickOutside from '@toolkit/util/useClickOutside';
import Label from './Label';

import './styles/Dropdown.scss';

type Props = React.PropsWithChildren & {
  label: string;
  className?: string;
  title?: string;
  rightAlingOnMobile?: boolean;
  disabled?: boolean;
};

const Dropdown: React.FC<Props> = ({ label, title, children, rightAlingOnMobile, className, disabled }) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const dropdownRef = useClickOutside(() => setIsOpen(false));

  return (
    <div
      className={classNames(
        'dropdown',
        { 'align-results--right': rightAlingOnMobile },
        { 'is--open': isOpen },
        { 'is--disabled': disabled },
        className,
      )}
      ref={dropdownRef}>
      <div className="dropdown-button" onClick={() => !disabled && setIsOpen(!isOpen)}>
        <div className="dropdown-label">{label}</div>
        <i className="material-symbols">expand_more</i>
      </div>
      <div className="dropdown-inner">
        {title && <Label>{title}</Label>}
        {children}
      </div>
    </div>
  );
};

export default Dropdown;
